import * as bootstrap from 'bootstrap';
import '@popperjs/core';

// LightGallery
import lightGallery from 'lightgallery';
import lgFullscreen from 'lightgallery/plugins/fullscreen';

import { initIpLogin } from './ipLogin.js';

window.addEventListener('load', function () {
    initIpLogin();


    // Initialize Carousels manually
    const carouselList = [].slice.call(document.querySelectorAll('.carousel'))
    carouselList.map(function (carouselEl) {
        return new bootstrap.Carousel(carouselEl)
    });
    
    // Light Gallery
    var elements = document.getElementsByClassName('lightgallery');

    for (var i = 0; i < elements.length; i++) {
        lightGallery(elements[i], {
            plugins: [lgFullscreen],
            selector: '.item',
            download: false,
            thumbnail: false,
            loop: false,
            hideControlOnEnd: true,
            autoplayControls: true,
            allowMediaOverlap: true,
            autoplay: false,
            zoom: false,
            share: false,
            pinterest: false,
            fullScreen: true,
            animateThumb: true,
            zoomFromOrigin: false,
            toggleThumb: false,
            mode: 'lg-fade',
            thumbHeight: '80px',
            thumbWidth: '80px',
            licenseKey: "BC0281CA-B5024C44-94CFC10D-48F52900"
        });
    }

    // FAQ Toggle Icons
    document.querySelectorAll('.faq-item').forEach(item => {
        const collapse = item.querySelector('.collapse');
        const icon = item.querySelector('.icon i');

        if (!collapse || !icon) return;

        collapse.addEventListener('show.bs.collapse', () => {
            icon.style.transform = 'rotate(180deg)';
        });

        collapse.addEventListener('hide.bs.collapse', () => {
            icon.style.transform = 'rotate(0deg)';
        });
    });
    
    // Tooltips
    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    });

    const langLinks = document.querySelectorAll('.language-switch a');

    langLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetUrl = this.href;

            const langValue = this.textContent.trim();

            setCookie('custom-language-set', langValue, 90);

            window.location.href = targetUrl;
        });
    });

    const toggleSwitch = document.getElementById('viewToggleSwitch');
    if (toggleSwitch) {
        const infoTableElements = document.querySelectorAll('.info-table');
        infoTableElements.forEach(tableElement => {
            let hasData = false;
            let hasDataAttr = true;
            
            const rows = tableElement.querySelectorAll('.row');
            rows.forEach(row => {
                if (row.getAttribute('data-has-data') === "true") {
                    hasData = true;
                }
                if (!row.hasAttribute('data-has-data')) {
                    hasDataAttr = false;
                }
            });
            if (!hasData && hasDataAttr) {
                tableElement.setAttribute('data-has-data', 'false');
            }

        })

        toggleSwitch.addEventListener('change', function(event) {
            const targetElements = document.querySelectorAll('[data-has-data="false"]');
            if (event.target.checked) {
                targetElements.forEach(function(el) {
                    if (el.classList.contains('row')) {
                        el.classList.add('d-flex');
                    }
                    else {
                        el.classList.add('d-block');
                    }
                });
            } else {
                targetElements.forEach(function(el) {
                    if (el.classList.contains('row')) {
                        el.classList.remove('d-flex');
                    }
                    else {
                        el.classList.remove('d-block');
                    }
                });
            }
        });
    }

    // Megamenu
    document.querySelectorAll(".megamenu").forEach(function (element) {
        element.addEventListener("click", function (e) {
            e.stopPropagation();
        });
    });

    document.querySelectorAll(".dropdown-item.dropdown-untermenu").forEach(function (element) {
        element.addEventListener("click", function (e) {
            e.preventDefault();
            var target = this.getAttribute("href");
            var navId = this.getAttribute("data-nav-id");

            // Hide elements with class matching (navId + "2")
            document.querySelectorAll("." + navId + "2").forEach(function (el) {
                el.style.display = "none";
            });

            // Show the target element
            var targetEl = document.querySelector(target);
            if (targetEl) {
                targetEl.style.display = ""; // Restores default display (e.g., block)
            }
        });
    });

    // Megamenu Close Button
    document.querySelectorAll(".close_button").forEach(function (element) {
        element.addEventListener("click", function (e) {
            document.querySelectorAll(".megamenu").forEach(function (menu) {
                menu.classList.remove("show");
            });
        });
    });

    document.querySelectorAll(".menu-button").forEach(function (element) {
        element.addEventListener("click", function (e) {
            e.preventDefault();
            var target = this.getAttribute("data-target");
            var targetEl = document.querySelector(target);

            if (targetEl) {
                // Replicates jQuery's .toggle()
                if (window.getComputedStyle(targetEl).display === "none") {
                    targetEl.style.display = "";
                } else {
                    targetEl.style.display = "none";
                }
            }
        });
    });

    // Login-Links (z. B. Toolbar) senden das Keycloak-Login-Formular ab (Partial KeycloakLoginForm)
    document.querySelectorAll('[data-keycloak-login]').forEach(function (element) {
        element.addEventListener('click', function (e) {
            var form = document.getElementById('keycloak_login_form');

            if (form) {
                e.preventDefault();
                form.requestSubmit();
            }
        });
    });

    // Toolbar.
    (function () {
        const toolbar = document.getElementById('svgw-toolbar');
        if (!toolbar) return;

        const tabs = toolbar.querySelectorAll('[data-toolbar-tab]');
        let current = null; // { tab, panel }

        function openPanel(tab) {
            const panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (!panel) return;

            if (current) closePanel(false);

            tab.setAttribute('aria-expanded', 'true');
            panel.classList.add('is-open');
            panel.removeAttribute('inert');
            panel.setAttribute('aria-hidden', 'false');
            toolbar.classList.add('is-open');
            current = { tab, panel };
        }

        function closePanel(returnFocus = true) {
            if (!current) return;
            const { tab, panel } = current;

            tab.setAttribute('aria-expanded', 'false');
            panel.classList.remove('is-open');
            panel.setAttribute('inert', '');
            panel.setAttribute('aria-hidden', 'true');
            toolbar.classList.remove('is-open');
            if (returnFocus) tab.focus();
            current = null;
        }

        // Tab click: toggle
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const isOpen = tab.getAttribute('aria-expanded') === 'true';
                isOpen ? closePanel(false) : openPanel(tab);
            });
        });

        // Close buttons inside the panels
        toolbar.querySelectorAll('[data-toolbar-close]').forEach(btn => {
            btn.addEventListener('click', () => closePanel());
        });

        // Escape key closes the panel
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape') closePanel();
        });

        // Click outside the toolbar closes the panel
        document.addEventListener('click', e => {
            if (current && !toolbar.contains(e.target)) closePanel(false);
        });
    })();

    // Search
    const dropdownLinks = document.querySelectorAll('.sortierung .dropdown-menu a');

    dropdownLinks.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            const parentSortierung = this.closest('.sortierung');

            if (parentSortierung) {
                const btn = parentSortierung.querySelector('.btn');
                if (btn) {
                    btn.innerHTML = `${this.textContent} <i class="fal fa-angle-down"></i>`;
                    btn.value = this.textContent;
                }
            }

            const sortFilters = document.querySelectorAll('.sortfilter');
            sortFilters.forEach(filter => {
                filter.value = this.textContent;
            });
        });
    });

});

// Helper function to set a cookie
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    // path=/ ensures the cookie is available across the whole site
    document.cookie = name + "=" + (value || "")  + expires + "; path=/; SameSite=Lax";
}

import '/src/svgw.ts'